import { render } from "./DisabledAccount.vue?vue&type=template&id=49729bc8"
import script from "./DisabledAccount.vue?vue&type=script&lang=js"
export * from "./DisabledAccount.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__